<template>
  <div class="dg-user-filter">
    <multiselect
      v-model="users"
      :options="usersSelect"
      track-by="value"
      label="text"

      selectLabel=""
      selectedLabel=""
      tagPlaceholder=""
      placeholder=""
      deselectLabel=""
      
      :searchable="true"
      :allow-empty="true"
      :multiple="true"
      openDirection="bottom"
      @select="select"
      @remove="select"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { find } from 'lodash'

export default {
  props: ['filter', 'cellKey'],
  data () {
    return {
      users: []
    }
  },
  watch: {
    filter () {
      if (!this.filter[this.cellKey]) this.users = []
    }
  },
  computed: {
    ...mapState([
      'userList'
    ]),
    usersSelect () {
      const userList = []

      for (let user of this.userList) {
        userList.push({ text: user.email || user.uid, value: user.uid })
      }

      return userList
    }
  },
  methods: {
    select () {
      this.$nextTick(() => {
        const users = []

        for (let user of this.users) {
          users.push(user.value)
        }
        if (this.users.length) Vue.set(this.filter, this.cellKey, users.join(','))
        else Vue.delete(this.filter, this.cellKey)

        this.applySelectedUsers()
      })
    },
    applySelectedUsers () {
      if (this.filter[this.cellKey]) {
        const users = this.filter[this.cellKey].split(',')
        const selectedUsers = []

        for (let user of users) {
          let match

          try {
            match = find(this.usersSelect, { value: eval(user) })
          } catch (err) {
            match = find(this.usersSelect, { value: user })
          }

          if (match) selectedUsers.push(match)
        }

        this.users = selectedUsers
      }
    }
  },
  created () {
    this.applySelectedUsers()
  }
}
</script>
